<template>
  <div class='breadcrumb'>
    <span>
      您现在所在位置：
    </span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  data () {
    return {
    }
  },
  props:{
    separator: {
      type: String,
      default: '>'
    }
  }
}
</script>

<style>
  .breadcrumb{
    width: 1200px;
    height: 60px;
    background: #fff;
    line-height: 60px;
    margin: 0 auto;
    color: #428bca;
    padding-left: 5px;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonBreadcrumb/breadcrumb.vue